import React from 'react';
import {
    Box,
    Icon,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Text,
} from '@chakra-ui/react';
import {HiQuestionMarkCircle} from 'react-icons/hi';

// 点击 "?" 图标弹出说明文字（用于易混淆设置项的用途说明）
const HelpTip = ({text}) => (
    <Popover placement="top" closeOnBlur>
        <PopoverTrigger>
            <Box
                as="button"
                type="button"
                display="inline-flex"
                alignItems="center"
                mx={1}
                cursor="pointer"
                aria-label="help"
            >
                <Icon as={HiQuestionMarkCircle} />
            </Box>
        </PopoverTrigger>
        <PopoverContent w="auto" maxW="320px">
            <PopoverArrow />
            <PopoverBody>
                <Text fontSize="sm">{text}</Text>
            </PopoverBody>
        </PopoverContent>
    </Popover>
);

export default HelpTip;
